import { render, staticRenderFns } from "./ChangePage.vue?vue&type=template&id=6527447e&scoped=true&"
import script from "./ChangePage.vue?vue&type=script&lang=js&"
export * from "./ChangePage.vue?vue&type=script&lang=js&"
import style0 from "./ChangePage.vue?vue&type=style&index=0&id=6527447e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6527447e",
  null
  
)

export default component.exports